import React, { Component } from 'react'
import Types, { TopBarTypes } from './type';
export type TopBarPropsType = {
    type: TopBarTypes,
    title?: string,
    preventBack?: boolean,
    onBack?: () => boolean,
    
}
export default class TopBar extends Component<TopBarPropsType> {
    render() {
        var type = this.props.type;
        if (!type) type = "default";
        var ITM = Types[type];
        return <ITM {...this.props}></ITM>
    }
}